const responseCodes = {
  AUTH401: 401,
  AUTH403: 403,
  SUCCESS200: 200,
  SUCCESS201:201
}
export default responseCodes;